/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.SelfServeRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */
export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */
export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type CollectionPreviewItem = {
  listingId: number;
  slug?: string;
  iconUrl?: string;
  name?: string;
};

export type CollectionWithPreviews = {
  id: number;
  title?: string;
  name: string;
  description: string;
  slug: string;
  tagline: string;
  itemCount: number;
  displayed: Default<boolean>;
  previewItems: Default<CollectionPreviewItem[]>;
  updatedAt?: number;
  htmlPageTitle: string;
  metaDescription: string;
};

export type CollectionsWithPreviewsResponse = {
  collections: Default<CollectionWithPreviews[]>;
};

export type SelfServeSearchRequest = {
  collectionId: number;
  published: boolean;
  language: string;
};

export type BaseQueryField =
  | 'LISTING_ID'
  | 'ORDERED_LISTING_ID'
  | 'PRODUCT_ID'
  | 'PRODUCT_TYPE'
  | 'OVERALL_RATING'
  | 'ADJUSTED_OVERALL_RATING'
  | 'REVIEW_COUNT'
  | 'INSTALL_COUNT'
  | 'FIRST_PUBLISHED_AT'
  | 'LISTING_LANGUAGE'
  | 'TIER'
  | 'WORKS_WITH_BREEZE'
  | 'WORKFLOW_ACTIONS'
  | 'WORKFLOW_ACTION_NAME'
  | 'WORKFLOW_ACTION_COMPATIBLE_OBJECT_TYPE_IDS'
  | 'WORKFLOW_ACTION_OBJECT_TYPE_IDS'
  | 'WORKFLOW_ACTION_IS_TOOL'
  | 'WORKFLOW_ACTION_SUPPORTED_CLIENT_APPS'
  | 'WORKFLOW_ACTION_SUPPORTED_CLIENTS'
  | 'PRODUCT_FEATURE_TYPE'
  | 'PRODUCT_FEATURE_NAME'
  | 'PRODUCT_FEATURE_METADATA'
  | 'BUILT_BY_HUBSPOT'
  | 'SOURCE_ID'
  | 'USE_CASES'
  | 'DISPLAY_TAG'
  | 'LISTING_NAME'
  | 'LISTING_SLUG'
  | 'CERTIFIED'
  | 'APP_PARTNER_TIER'
  | 'TECHNOLOGY_PARTNER_TIER'
  | 'CONNECTION_TYPE'
  | 'IS_BREEZE_CONNECTOR'
  | 'SYNC_DIRECTION'
  | 'CATEGORY'
  | 'PRICING_PLAN'
  | 'HUBSPOT_FEATURES'
  | 'SUPPORT_LANGUAGES'
  | 'APP_LANGUAGES'
  | 'TOOL_INTEGRATIONS'
  | 'AGENT_TYPE'
  | 'AGENT_TEAM'
  | 'HAS_UBB'
  | 'PROFILE_SOLUTIONS_PARTNER_TIER'
  | 'PROFILE_BUDGET'
  | 'PROFILE_CATALOG_SERVICES'
  | 'PROFILE_INDUSTRIES'
  | 'PROFILE_LANGUAGES'
  | 'PROFILE_ACCREDITATIONS'
  | 'PROFILE_CERTIFICATIONS'
  | 'PROFILE_SUPPORTED_LISTINGS'
  | 'PROFILE_LOCATION_COUNTRY'
  | 'PROFILE_OFFICE_LOCATION'
  | 'PROFILE_PORTAL_ID'
  | 'OBJECTIVE'
  | 'HUB_PLAN'
  | 'REQUIRED_APP_IDS'
  | 'REQUIRED_AGENT_IDS'
  | 'INSTALLED'
  | 'PORTAL_INSTALLABLE'
  | 'REQUIRED_APPS_INSTALLED'
  | unhandledEnumCase;

export type MarketplaceSearchRequest = {
  search?: string;
  language: string;
  filter?: Filter;
  sorts: Default<Sort[]>;
  recommendations: Default<RecommendedListing[]>;
  enableSpellingCorrection: Default<boolean>;
  offset: Default<number>;
  length: Default<number>;
  searchSource: Default<SearchSource>;
  debug: Default<boolean>;
  alwaysIncludeBetaListings: Default<boolean>;
};

export type RecommendedListing = { listingId: number; score: number };

export type SearchSource = 'STANDARD' | 'SEARCH_BAR' | unhandledEnumCase;

export type Sort = { field: BaseQueryField; order: SortOrder };

export type SortOrder = 'ASC' | 'DESC' | unhandledEnumCase;

export const BooleanFilterQueryTypename =
  'com.hubspot.marketplace.search.models.filters.BooleanFilterQuery';
export const BooleanFilterQueryDiscriminant = 'BooleanFilterQuery';
export const BooleanFilterQueryDiscriminantKey = '@type';
export type BooleanFilterQuery = {
  values: Default<boolean[]>;
  greaterThanOrEqualTo?: boolean;
  lessThanOrEqualTo?: boolean;
  negation: Default<boolean>;
  clause: Default<QueryClause>;
  __typename: 'com.hubspot.marketplace.search.models.filters.BooleanFilterQuery';
} & { '@type'?: 'BooleanFilterQuery' };

export const ExistsFilterQueryTypename =
  'com.hubspot.marketplace.search.models.filters.ExistsFilterQuery';
export const ExistsFilterQueryDiscriminant = 'ExistsFilterQuery';
export const ExistsFilterQueryDiscriminantKey = '@type';
export type ExistsFilterQuery = {
  negation: Default<boolean>;
  clause: Default<QueryClause>;
  __typename: 'com.hubspot.marketplace.search.models.filters.ExistsFilterQuery';
} & { '@type'?: 'ExistsFilterQuery' };

export type Filter = {
  filterGroups: Default<FilterGroup[]>;
  clause: Default<QueryClause>;
  negation: Default<boolean>;
};

export type FilterGroup = {
  filtersByField: Default<Record<string, FilterQuery[]>>;
  clause: Default<QueryClause>;
  negation: Default<boolean>;
};

export const FilterQueryDiscriminantKey = '@type';
export type FilterQuery =
  | BooleanFilterQuery
  | ExistsFilterQuery
  | FloatFilterQuery
  | LongFilterQuery
  | StringFilterQuery;

export const FloatFilterQueryTypename =
  'com.hubspot.marketplace.search.models.filters.FloatFilterQuery';
export const FloatFilterQueryDiscriminant = 'FloatFilterQuery';
export const FloatFilterQueryDiscriminantKey = '@type';
export type FloatFilterQuery = {
  values: Default<number[]>;
  greaterThanOrEqualTo?: number;
  lessThanOrEqualTo?: number;
  negation: Default<boolean>;
  clause: Default<QueryClause>;
  __typename: 'com.hubspot.marketplace.search.models.filters.FloatFilterQuery';
} & { '@type'?: 'FloatFilterQuery' };

export const LongFilterQueryTypename =
  'com.hubspot.marketplace.search.models.filters.LongFilterQuery';
export const LongFilterQueryDiscriminant = 'LongFilterQuery';
export const LongFilterQueryDiscriminantKey = '@type';
export type LongFilterQuery = {
  values: Default<number[]>;
  greaterThanOrEqualTo?: number;
  lessThanOrEqualTo?: number;
  negation: Default<boolean>;
  clause: Default<QueryClause>;
  __typename: 'com.hubspot.marketplace.search.models.filters.LongFilterQuery';
} & { '@type'?: 'LongFilterQuery' };

export type QueryClause = 'AND' | 'OR' | unhandledEnumCase;

export const StringFilterQueryTypename =
  'com.hubspot.marketplace.search.models.filters.StringFilterQuery';
export const StringFilterQueryDiscriminant = 'StringFilterQuery';
export const StringFilterQueryDiscriminantKey = '@type';
export type StringFilterQuery = {
  values: Default<string[]>;
  greaterThanOrEqualTo?: string;
  lessThanOrEqualTo?: string;
  negation: Default<boolean>;
  clause: Default<QueryClause>;
  __typename: 'com.hubspot.marketplace.search.models.filters.StringFilterQuery';
} & { '@type'?: 'StringFilterQuery' };

export type GetSearchRequestForCollectionRequestType =
  Requestify<SelfServeSearchRequest>;
export type GetSearchRequestForCollectionResponseType =
  MarketplaceSearchRequest;
export type GetSearchRequestForCollectionErrorType = EmptyError &
  HubspotMetadata;
export const getSearchRequestForCollectionRpc: ChirpAvroRpcDetails<
  GetSearchRequestForCollectionRequestType,
  GetSearchRequestForCollectionResponseType,
  GetSearchRequestForCollectionErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.quality.rpc.SelfServeRpc',
  rpcName: 'getSearchRequestForCollection',
  auth: 'app',
  fingerprint: 'Wo7LA-eDawS-vgUkdrF825wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAllPublishedCollectionsResponseType =
  CollectionsWithPreviewsResponse;
export type GetAllPublishedCollectionsErrorType = EmptyError & HubspotMetadata;
export const getAllPublishedCollectionsRpc: ChirpAvroRpcDetails<
  undefined,
  GetAllPublishedCollectionsResponseType,
  GetAllPublishedCollectionsErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.quality.rpc.SelfServeRpc',
  rpcName: 'getAllPublishedCollections',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAGFx25esjAAZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
